import React from 'react';
import PropTypes from 'prop-types';

import './change-amount.scss';

const ChangeAmount = props => {
  const { disableDecrease, disableIncrease, onUpdateValue, small, step, suffix, value, valueStyle, wrapperClass } = props;
  const buttonClass = `change-amount ${small ? 'change-amount--small' : ''}`;
  return <div className={wrapperClass}>
    <button
      type="button"
      disabled={disableDecrease}
      className={buttonClass}
      onClick={() => onUpdateValue(value - step)}>-</button>
    <div className="nowrap" style={valueStyle}>{value} {suffix}</div>
    <button
      type="button"
      className={buttonClass}
      disabled={disableIncrease}
      onClick={() => onUpdateValue(value + step)}>+</button>
  </div>
};

ChangeAmount.ropTypes = {
  disableDecrease: PropTypes.bool,
  disableIncrease: PropTypes.bool,
  onUpdateValue: PropTypes.func.isRequired,
  small: PropTypes.bool,
  step: PropTypes.number,
  suffix: PropTypes.string,
  value: PropTypes.number.isRequired,
  valueStyle: PropTypes.object,
  wrapperClass: PropTypes.string,
}

ChangeAmount.defaultProps = {
  disableDecrease: false,
  disableIncrease: false,
  small: false,
  step: 1,
  wrapperClass: 'row align-items-center flex-nowrap',
}

export default React.memo(ChangeAmount);
